import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-update-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './update-button.component.html',
  styleUrl: './update-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateButtonComponent {
  readonly buttonDisabled = input<boolean>(false);

  @Output() readonly onUpdateClicked = new EventEmitter<void>();

  /**
   * Emits the search data event.
   *
   * @returns void
   */
  public onSubmit(): void {
    this.onUpdateClicked.emit();
  }
}
